import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaChartBar } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, NavDropdown } from 'react-bootstrap';
import { logout } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const Header = () => {
    const auth = useAuth() || {};
    const currentUser = auth.currentUser || null;
    const updateUser = auth.updateUser || (() => { });

    const navigate = useNavigate();
    const location = useLocation();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const handleLogout = () => {
        logout();
        updateUser(null);
        navigate('/');
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="top-header">
                <Container>
                    <Row className="align-items-center">
                        <Col className="d-flex align-items-center justify-content-between">
                            <div className="logo-container d-flex align-items-center">
                                <Link to="/" className="logo-link">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/logo.png`}
                                        alt="OtoPrime Logo"
                                        className="logo"
                                    />
                                </Link>

                                <ul className="inline-nav-menu">
                                    <li><Link to="/sales-system">Satış Sistemi</Link></li>
                                    <li><Link to="/about">Hakkımızda</Link></li>
                                    <li><Link to="/contact">İletişim</Link></li>
                                    <li><Link to="/faq">Sık Sorulan Sorular</Link></li>
                                    <li><Link to="/blog">Blog</Link></li>  
                                </ul>
                            </div>

                            <div className="desktop-auth d-none d-lg-flex">
                                {currentUser ? (
                                    <div className="greeting">
                                        <NavDropdown
                                            title={`Merhaba, ${currentUser.name || 'Kullanıcı'}`}
                                            id="user-dropdown"
                                        >
                                            <NavDropdown.Item as={Link} to="/profile">Profilim</NavDropdown.Item>

                                            {/* ADMIN MENÜSÜ - GÜNCELLENMİŞ */}
                                            {currentUser.userType === 'admin' && (
                                                <>
                                                    <NavDropdown.Divider />

                                                    {/*  Admin Analytics */}
                                                    <NavDropdown.Item as={Link} to="/admin/analytics">
                                                        <FaChartBar className="me-2" />
                                                        📊 Admin Dashboard
                                                    </NavDropdown.Item>

                                                    {/*  Kredi Hesaplama */}
                                                    <NavDropdown.Item as={Link} to="/admin/credit-calculation">
                                                        🧮 Kredi Hesaplama
                                                    </NavDropdown.Item>

                                                    {/*  Banka Kredi Takip */}
                                                    <NavDropdown.Item as={Link} to="/admin/bank-credit-management">
                                                        🏦 Banka Kredi Takip
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/admin/senet-takip">
                                                        📋 Senet Takip
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Divider />

                                                    {/* Sözleşme Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/reports">
                                                        📄 Sözleşme ve Senet
                                                    </NavDropdown.Item>

                                                    {/*  Sözleşmesiz Senet */}
                                                    <NavDropdown.Item as={Link} to="/standalone-senets">
                                                        📑 Senet
                                                    </NavDropdown.Item>
                                                                                 
                                                    {/* Araç Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/vehicles">
                                                        🚗 Araç Yönetimi
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Divider />

                                                    {/* Başvuru Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/applications">
                                                        📋 Başvuru Yönetimi
                                                    </NavDropdown.Item>
                                                 
                                                    {/* Marka Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/brand-management">
                                                        🏷️ Marka Yönetimi
                                                    </NavDropdown.Item>

                                                    {/* Sistem Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/user-management">
                                                        👥 Kullanıcı Yönetimi
                                                    </NavDropdown.Item>  

                                                    {/* Personel Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/employee-management">
                                                        👨‍💼 Personel Yönetimi
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/admin/logs">
                                                        📊 İşlem Logları
                                                    </NavDropdown.Item>

                                                    {/* Blog Yönetimi */}
                                                    <NavDropdown.Item as={Link} to="/admin/my-blogs">
                                                        📄 Bloglarım
                                                    </NavDropdown.Item>

                                                </>
                                            )}

                                            {/* REPRESENTATIVE (TEMSİLCİ) MENÜSÜ */}
                                            {currentUser.userType === 'representative' && (
                                                <>
                                                    <NavDropdown.Divider />

                                                    {/*  Kredi Hesaplama */}
                                                    <NavDropdown.Item as={Link} to="/admin/credit-calculation">
                                                        🧮 Kredi Hesaplama
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/admin/senet-takip">
                                                        📋 Senet Takip
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Divider />

                                                    <NavDropdown.Item as={Link} to="/admin/reports">
                                                        📄 Sözleşme ve Senet
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/standalone-senets">
                                                        📑 Senet
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/admin/vehicles">
                                                        🚗 Araç Yönetimi
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Divider />

                                                    <NavDropdown.Item as={Link} to="/admin/applications">
                                                        📋 Başvuru Yönetimi
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/admin/brand-management">
                                                        🏷️ Marka Yönetimi
                                                    </NavDropdown.Item>

                                                    <NavDropdown.Item as={Link} to="/representative/my-blogs">
                                                        📄 Bloglarım
                                                    </NavDropdown.Item>
                                                </>
                                            )}

                                            {/* PAZARLAMA MENÜSÜ */}
                                            {currentUser.userType === 'marketing' && (
                                                <>
                                                    <NavDropdown.Divider />
                                                    <NavDropdown.Item as={Link} to="/admin/credit-calculation">
                                                        🧮 Kredi Hesaplama
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/admin/reports">
                                                        📄 Sözleşme ve Senet
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/standalone-senets">
                                                        📑 Senet
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/admin/applications">
                                                        📋 Başvuru Yönetimi
                                                    </NavDropdown.Item>
                                                </>
                                            )}

                                            {/* ✅ DEALER MENÜSÜ - GÜNCELLENDİ */}
                                            {currentUser.userType === 'dealer' && (
                                                <>
                                                    <NavDropdown.Divider />
                                                    <NavDropdown.Item as={Link} to="/dealer/applications">
                                                        📋 Başvurularım
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/application">
                                                        ➕ Müşteri Adına Başvuru Yap
                                                    </NavDropdown.Item>
                                                </>
                                            )}

                                            <NavDropdown.Divider />
                                            <NavDropdown.Item onClick={handleLogout}>Çıkış Yap</NavDropdown.Item>
                                        </NavDropdown>
                                    </div>
                                ) : (
                                    <div className="auth-buttons">
                                        <Link to="/login" className="btn btn-custom-customer me-2">
                                            Üye Girişi
                                        </Link>
                                        <Link to="/apply" className="btn btn-custom-apply">
                                            Hemen Başvur
                                        </Link>
                                    </div>
                                )}
                            </div>

                            <button
                                className="mobile-menu-toggle d-lg-none"
                                onClick={toggleMobileMenu}
                                aria-label="Menüyü aç/kapat"
                            >
                                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                            </button>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
                <Container>
                    <nav className="mobile-nav">
                        <div className="mobile-nav-section">
                            <Link to="/sales-system" className="mobile-nav-link">Satış Sistemi </Link>
                            <Link to="/about" className="mobile-nav-link">Hakkımızda </Link>
                            <Link to="/contact" className="mobile-nav-link">İletişim </Link>
                            <Link to="/faq" className="mobile-nav-link">Sık Sorulan Sorular </Link>
                            <Link to="/blog" className="mobile-nav-link">Blog </Link>
                        </div>

                        <div className="mobile-nav-section">
                            {currentUser ? (
                                <>
                                    <div className="mobile-user-greeting">
                                        Merhaba, {currentUser.name || 'Kullanıcı'}
                                    </div>
                                    <Link to="/profile" className="mobile-nav-link">
                                        Profilim
                                    </Link>

                                    {/* MOBILE ADMIN MENÜSÜ - GÜNCELLENMİŞ */}
                                    {currentUser.userType === 'admin' && (
                                        <>
                                            {/* YENİ: Admin Analytics */}
                                            <Link to="/admin/analytics" className="mobile-nav-link">
                                                📊 Admin Dashboard
                                            </Link>

                                            {/* YENİ: Kredi Yönetimi */}
                                            <Link to="/admin/credit-calculation" className="mobile-nav-link">
                                                🧮 Kredi Yönetimi
                                            </Link>

                                            {/* YENİ: Banka Kredi Takip */}
                                            <Link to="/admin/bank-credit-management" className="mobile-nav-link">
                                                🏦 Banka Kredi Takip
                                            </Link>

                                            <Link to="/admin/senet-takip" className="mobile-nav-link">
                                                📋 Senet Takip
                                            </Link>

                                            <NavDropdown.Divider />

                                            {/* Sözleşme Yönetimi */}
                                            <Link to="/admin/reports" className="mobile-nav-link">
                                                📄 Sözleşme ve Senet
                                            </Link>
                                           
                                            <Link to="/standalone-senets" className="mobile-nav-link">
                                                📑 Senet
                                            </Link>

                                            {/* Araç Yönetimi */}
                                            <Link to="/admin/vehicles" className="mobile-nav-link">
                                                🚗 Araç Yönetimi
                                            </Link>

                                            <NavDropdown.Divider />

                                            {/* Başvuru Yönetimi */}
                                            <Link to="/admin/applications" className="mobile-nav-link">
                                                📋 Başvuru Yönetimi
                                            </Link>

                                            <Link to="/admin/brand-management" className="mobile-nav-link">
                                                🏷️ Marka Yönetimi
                                            </Link>

                                            {/* Sistem Yönetimi */}
                                            <Link to="/admin/user-management" className="mobile-nav-link">
                                                👥 Kullanıcı Yönetimi
                                            </Link>   

                                            {/* Personel Yönetimi */}
                                            <Link to="/admin/employee-management" className="mobile-nav-link">
                                                👨‍💼 Personel Yönetimi
                                            </Link>

                                            <Link to="/admin/logs" className="mobile-nav-link">
                                                📊 İşlem Logları
                                            </Link>

                                            <Link to="/admin/my-blogs" className="mobile-nav-link">
                                                📄 Bloglarım
                                            </Link>
                                            
                                        </>
                                    )}

                                    {/* MOBILE REPRESENTATIVE (TEMSİLCİ) MENÜSÜ */}
                                    {currentUser.userType === 'representative' && (
                                        <>
                                            <Link to="/admin/credit-calculation" className="mobile-nav-link">
                                                🧮 Kredi Hesaplama
                                            </Link>

                                            <Link to="/admin/senet-takip" className="mobile-nav-link">
                                                📋 Senet Takip
                                            </Link>

                                            <Link to="/admin/reports" className="mobile-nav-link">
                                                📄 Sözleşme ve Senet
                                            </Link>

                                            <Link to="/standalone-senets" className="mobile-nav-link">
                                                📑 Senet
                                            </Link>

                                            <Link to="/admin/vehicles" className="mobile-nav-link">
                                                🚗 Araç Yönetimi
                                            </Link>

                                            <Link to="/admin/applications" className="mobile-nav-link">
                                                📋 Başvuru Yönetimi
                                            </Link>

                                            <Link to="/admin/brand-management" className="mobile-nav-link">
                                                🏷️ Marka Yönetimi
                                            </Link>

                                            <Link to="/representative/my-blogs" className="mobile-nav-link">
                                                📄 Bloglarım
                                            </Link>
                                        </>
                                    )}

                                    {/* MOBILE PAZARLAMA MENÜSÜ */}
                                    {currentUser.userType === 'marketing' && (
                                        <>
                                            <Link to="/admin/credit-calculation" className="mobile-nav-link">
                                                🧮 Kredi Hesaplama
                                            </Link>
                                            <Link to="/admin/reports" className="mobile-nav-link">
                                                📄 Sözleşme ve Senet
                                            </Link>
                                            <Link to="/standalone-senets" className="mobile-nav-link">
                                                📑 Senet
                                            </Link>
                                            <Link to="/admin/applications" className="mobile-nav-link">
                                                📋 Başvuru Yönetimi
                                            </Link>
                                        </>
                                    )}

                                    {/* ✅ MOBILE DEALER MENÜSÜ - GÜNCELLENDİ */}
                                    {currentUser.userType === 'dealer' && (
                                        <>
                                            <Link to="/dealer/applications" className="mobile-nav-link">
                                                📋 Başvurularım
                                            </Link>
                                            <Link to="/application" className="mobile-nav-link">
                                                ➕ Müşteri Adına Başvuru Yap
                                            </Link>
                                        </>
                                    )}

                                    <button
                                        onClick={handleLogout}
                                        className="mobile-nav-link mobile-logout-btn"
                                    >
                                        Çıkış Yap
                                    </button>
                                </>
                            ) : (
                                <div className="mobile-auth-buttons">
                                    <Link to="/login" className="btn btn-custom-customer mobile-auth-btn">
                                        Üye Girişi
                                    </Link>
                                    <Link to="/apply" className="btn btn-custom-apply mobile-auth-btn">
                                        Hemen Başvur
                                    </Link>
                                </div>
                            )}
                        </div>
                    </nav>
                </Container>
            </div>
        </header>
    );
};

export default Header;